import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MenuItem} from "primeng/api";
import {combineLatest as observableCombineLatest, Observable} from "rxjs";
import {HttpClientService} from "../../core/services/http-client.service";
import {environment} from "../../../environments/environment";
import {ToastService} from "../../core/services/toast.service";
import {CommonService} from "../../core/services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BreakpointObserver} from "@angular/cdk/layout";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit{
  tabs: MenuItem[] = [{
    "label" : "Profile",
    "icon" : "pi pi-building-columns",
    "route" : "/user/profile",
  },{
    "label" : "My Orders",
    "icon" : "pi pi-box",
    "route" : "/user/profile/orders",
  },{
    "label" : "My Addresses",
    "icon" : "pi pi-address-book",
    "route" : "/user/profile/address",
  },{
    "label" : "Offers",
    "icon" : "pi pi-gift",
    "route" : "/offer",
  },{
    "label" : "Change Password",
    "icon" : "pi pi-file-edit",
    "route": "/changePassword",
  },{
    "label" : "Policy",
    "icon" : "pi pi-file-check",
    "expanded": false,
    "items": [
      {
        "label": 'Terms Of Use',
        "icon": 'pi pi-address-book',
        "route": "/policy/terms",
      },
      {
        "label": 'Privacy',
        "icon": 'pi pi-gift',
        "route": "/policy/privacy-policy",
      },
      {
        "label": 'Return Policy',
        "icon": 'pi pi-file-edit',
        "route": "/policy/return-policy",
      },
      {
        "label": 'Disclaimer',
        "icon": 'pi pi-file-check',
        "route": "/policy/disclaimer-policy",
      }
    ]
  }
  ];

  visible: boolean=false;
  fullName: any;
  email: any;
  address: any;
  customer: any;
  url: string;
  loading: boolean;
  addresses: any[];
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  editModal: boolean=false;
  changeModal: boolean=false;
  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(private http: HttpClientService, private toast: ToastService,  private store: CommonService,private router: Router,
              public common: CommonService, private route: ActivatedRoute,private breakpointObserver: BreakpointObserver) {
    this.customer = this.store.getStorage('customer');
    if (this.customer.profileImageId) {
      this.customer.profileImageUrl = `${environment.API_ENDPOINT}document/${this.customer.profileImageId}`;
    }
  }

  navigateToTab(tab: MenuItem): void {
    if (tab.route === '/changePassword') {
      this.changeModal=true;
    }
    else if(tab.items){
      tab.expanded = !tab.expanded;
    }
    else if (tab.route === '/user/profile'&& this.isSmallScreen()) {
      this.router.navigate(['/user/profile/info']);
    }
    else {
      this.router.navigate([tab.route]);
    }
  }

  ngOnInit(): void {
    this.common.setStorage("customer", this.customer);
    if(this.customer.smartSeller){
      this.tabs.splice(2, 0, {
        "label" : "Smart Seller",
        "icon" : "pi pi-indian-rupee",
        "route": "/associates/dashboard",
      });
    }
    observableCombineLatest([
      this.route.data,
      this.route.queryParams,
      this.route.params,
    ]).subscribe((bothParams) => {

      this.getCustomerById(this.customer.id)
        .subscribe(data => {
          this.loading = false;
          if (data['responseStatus'].toLowerCase() == 'success') {
            this.customer = data['response'];
            this.user.mobile = this.customer.mobileNumber
            if(this.customer.profileImageId) this.customer.profileImageUrl = `${environment.API_ENDPOINT}document/${this.customer.profileImageId}`;
          }
        });
    });
  }
  openDialog(): void {
    this.visible = true;
    this.editModal=true;
  }
  isSmallScreen(): boolean {
    return this.breakpointObserver.isMatched('(max-width: 768px)');
  }

  triggerFileInput() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadFile(file);
    } else {
    }
  }
  isEmailFilled(): boolean {
    return !!this.customer.emailId;
  }
  isNameFilled(): boolean {
    return !!this.customer.firstName;
  }
  logOut(){
    this.store.removeStorage('customer');
    this.store.setLoggedIn(false);
    this.router.navigate(['/']);
  }
  uploadFile(file: File): void {
    const formData = new FormData();
    formData.append('file', file, file.name);

    this.http.postFile('document-upload', formData).subscribe(
      data => {
        if (data.responseStatus.toLowerCase() === 'success' && data.response.result) {
          this.customer.profileImageId = data.response.document_id;
          this.http.post("store/updateCustomer", this.customer).subscribe((res) => {
            if (res.responseStatus.toLowerCase() == "success") {
              this.customer.profileImageUrl = `${environment.API_ENDPOINT}document/${this.customer.profileImageId}`;
              this.toast.success('Profile image updated successfully');
            } else {
              this.toast.info('Unable to upload image');
            }
          });
        } else {
          this.toast.error(data.response.message);
        }
      },
      error => {
        this.toast.error('Failed to upload image');
      }
    );
  }
  public user: any = {
  }
  public getCustomerById(id: Number): Observable<any> {
    return this.http.get(`store/getCustomerById/${id}`);
  };
  public changeuserPassword(params) {
    return this.http.post("store/changePassword", params);
  }
  changePassword() {
    if (this.user.password !== this.user.confirmPassword) {
      this.toast.error("Passwords do not match");
      return;
    }

    if (this.user.password.length < 8) {
      this.toast.error("Password length should be at least 8 characters");
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
    if (!passwordRegex.test(this.user.password)) {
      this.toast.error(
        "Password must include at least one lowercase letter, one uppercase letter, and one number"
      );
      return;
    }

    this.loading = true;
    this.changeuserPassword(this.user).subscribe(
      (response) => {
        this.loading = false;
        if (response?.responseStatus?.toLowerCase() === "success") {
          this.toast.success("Password reset successful");
          this.common.setStorage("customer", this.customer);
          this.visible=false;
          this.changeModal=false;
          this.common.setLoggedIn(true);
          this.router.navigate(['/auth'], { queryParams: { customerId: this.customer.id } });

        } else {
          this.toast.error("Failed to reset password. Please try again.");
        }
      },
      (error) => {
        this.loading = false;
        this.toast.error("An error occurred while resetting the password");
      }
    );
  }
  toggleOldPasswordVisibility() {
    this.showOldPassword = !this.showOldPassword;
  }

  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  submitForm(): void {
    this.http.post('store/updateCustomer', this.customer).subscribe(
      response => {
        this.toast.success('Profile updated successfully');
        this.store.setStorage('customer', this.customer);
        this.visible = false;
      },
      error => {
        this.toast.error('Failed to update profile');
      }
    );
  }

}
